import { render, staticRenderFns } from "./MailList.vue?vue&type=template&id=7403a430&scoped=true"
import script from "./MailList.vue?vue&type=script&lang=js"
export * from "./MailList.vue?vue&type=script&lang=js"
import style0 from "./MailList.vue?vue&type=style&index=0&id=7403a430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7403a430",
  null
  
)

export default component.exports